import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import queryString from "query-string";
import __ from "utils/i18n";
import { Field, Form } from "components/forms";
import { CustomField } from "components/forms/fields";
import DateRangeInput from "components/forms/inputs/DateRangeInput";
import { backendUrl } from "config/envConfig";
import ButtonLoader from "containers/Dashboard/components/ButtonLoader/ButtonLoader";

export const MovementsReportWidget = ({ filters, token }) => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const merchantCode = useSelector((state) => state.login?.user?.merchantCode);

  const formatOptions = [
    { value: "xls", label: "XLS" },
    { value: "csv", label: "CSV" }
  ];

  const downloadReport = async (values) => {
    setErrorMessage();
    setIsLoading(true);
    
    if (!values.dateRange?.startDate || !values.dateRange?.endDate) {
      setErrorMessage("Por favor selecciona un rango de fechas válido.");
      setIsLoading(false);
      return;
    }
    
    const query = queryString.stringify({
      startDate: moment(values.dateRange.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.dateRange.endDate).format("YYYY-MM-DD"),
      downloadType: values.format,
      accountName: "",
      idFiscal: "",
      externalId: "",
      page: 1,
      results: 50,
      simpleType: ""
    });

    try {
      const downloadOperationResponse = await fetch(`${backendUrl}/proxy/api/v1/downloadMovements?${query}`, {
        method: "GET",
        headers: {
          "x-Authentication-Token": token,
          "x-request-download": "stream",
        },
      });

      if (downloadOperationResponse.status === 204) {
        setErrorMessage(__("dashboard.sections.sales.transactionReportNoTXInPeriod"));
      } else if (downloadOperationResponse.status > 300) {
        setErrorMessage(__("dashboard.sections.sales.transactionReportError"));
      } else {
        const reader = downloadOperationResponse.body.getReader();
        const stream = new ReadableStream({
          start(controller) {
            async function pump() {
              const { done, value } = await reader.read();
              if (done) {
                controller.close();
                return;
              }
              controller.enqueue(value);
              return pump();
            }
            return pump();
          },
        });
        const streamResponse = new Response(stream);
        const blob = await streamResponse.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `movements_${Date.now()}.${values.format}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading movements report:", error);
      setErrorMessage(__("dashboard.sections.sales.transactionReportError"));
    }
    setIsLoading(false);
  };

  return (
    <Form
      defaultValues={{
        dateRange: {
          startDate: filters.startDate,
          endDate: filters.endDate,
        },
        format: "xls",
      }}
    >
      {(form) => (
        <>
          <Button 
            color="primary" 
            className="ml-2"
            onClick={() => {
              setShowModal(true);
              setErrorMessage();
            }}
          >
            {__("dashboard.sections.sales.movementsReport")}
          </Button>
          <Modal
            className="reportWidgetModal"
            isOpen={showModal}
            toggle={() => setShowModal(false)}
          >
            <ModalHeader>
              {__("dashboard.sections.sales.movementsReport")}
            </ModalHeader>
            <ModalBody>
              <div className="text-center">
                <CustomField field="dateRange" onChange={() => setErrorMessage()}>
                  <DateRangeInput />
                </CustomField>
              </div>
              <div>
                {errorMessage && (
                  <div className='one-line-warning one-line-warning-transaction-report'>
                    <i className="mdi mdi-information buttom-radius"></i>
                    <p>{errorMessage}</p>
                  </div>
                )}
              </div>
              <Field
                block
                field="format"
                label={__("dashboard.sections.sales.form.format.label")}
                placeholder={__(
                  "dashboard.sections.sales.form.format.placeholder"
                )}
                type="select"
                options={formatOptions}
              />
              <div className="text-center mt-3">
                <small className="text-muted">
                  Merchant: <strong>{merchantCode}</strong>
                </small>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                className="buttom-radius"
                onClick={() => setShowModal(false)}
              >
                {__("actions.cancel")}
              </Button>
              <ButtonLoader
                text={__("actions.download")}
                isLoading={isLoading}
                onClick={() => {
                  downloadReport(form.values);
                }}
              />
            </ModalFooter>
          </Modal>
        </>
      )}
    </Form>
  );
};


